var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 21.0001C11.9334 21.0001 11.3334 21.6001 11.3334 22.3334H20.6667C20.6667 21.6001 20.0667 21.0001 19.3334 21.0001H16.6667V19.6667H18.6667C19.4 19.6667 20 19.0667 20 18.3334H14.6667C13.56 18.3334 12.6667 17.4401 12.6667 16.3334C12.6667 15.6067 13.06 14.9734 13.6467 14.6201C13.92 15.0134 14.3534 15.2867 14.8667 15.3267C15.3334 15.3667 15.7734 15.2001 16.1 14.9134L16.4934 15.9867L17.12 15.7601L17.3467 16.3867L18.6 15.9334L18.3734 15.3067L19 15.0801L17.1734 10.0667L16.5467 10.2934L16.32 9.66675L15.0667 10.1201L15.2934 10.7467L14.6667 10.9801L15.04 12.0134C14.26 11.9867 13.58 12.5134 13.3867 13.2534C12.18 13.7601 11.3334 14.9467 11.3334 16.3334C11.3334 18.1734 12.8267 19.6667 14.6667 19.6667V21.0001H12.6667ZM16.5734 11.3467L17.7134 14.4801L17.0867 14.7067L15.9467 11.5734L16.5734 11.3467ZM15 13.0001C15.3667 13.0001 15.6667 13.3001 15.6667 13.6667C15.6667 14.0334 15.3667 14.3334 15 14.3334C14.6334 14.3334 14.3334 14.0334 14.3334 13.6667C14.3334 13.3001 14.6334 13.0001 15 13.0001Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthTech);
export default __webpack_public_path__ + "static/media/healthTech.8b81ef680ec7e7fd173e1f9b031c7f31.svg";
export { ForwardRef as ReactComponent };